import '@moonbeam-network/api-augment';
import { ApiPromise } from '@polkadot/api';
import { ApiContext } from 'providers/ApiProvider';
import { useContext } from 'react';

export const useApi = (): ApiPromise | undefined => {
  return useContext(ApiContext);
};
